import { useRecoilState, useRecoilValue } from 'recoil';
import * as Atom from '../recoil';
import { IS_MTG_EXPOSED, PAGE_NM } from '../types/types';
import useBeacon from '../hooks/useBeacon';
import { beaconSelector } from '../recoil/selector';
import { useEffect } from 'react';
import { useTerms } from '../hooks/useTerms';
import { useLocation } from 'react-router-dom';

const usePartners = () => {
  const location: any = useLocation();
  const [loanList] = useRecoilState(Atom.loanList);
  const [baseContents] = useRecoilState(Atom.baseContents);
  const beaconData = useRecoilValue(beaconSelector);
  const beacon = useBeacon({
    mediaCd: beaconData.mediaCd,
    custSeq: beaconData.custSeq,
    srcCd: beaconData.srcCd,
    pageName:
      location?.state?.ref_page === PAGE_NM.HOME
        ? PAGE_NM.PARTNERS
        : PAGE_NM.MTG_PARTNERS,
  });
  useEffect(() => {
    beacon.sendViewPage();
  }, []);
  const sendBeaconClkBtnLoanApp = (btnNm: string) => {
    beacon.sendClkBtnLoanApp({
      properties: { btnNm },
    });
  };
  const sendBeaconClkBtnAgree = (btnNm: string) => {
    beacon.sendClkBtnAgree({
      properties: { btnNm },
    });
  };

  const refPage = location.state?.ref_page;
  const termsProps =
    refPage === PAGE_NM.MTG_HOME
      ? { EVENT_STATE: 'mtg', ref_page: refPage }
      : refPage;
  const terms = useTerms(termsProps);

  const showTerms = () => {
    if (IS_MTG_EXPOSED && refPage === PAGE_NM.MTG_HOME) {
      terms.showTerm({ EVENT_STATE: 'mtg' });
    } else {
      terms.showTerm();
    }
  };

  return {
    activeCompList: baseContents?.compDetail?.activeCompList,
    toBeExposedCompList: baseContents?.compDetail?.toBeExposedCompList,
    compByLoanCategory: baseContents?.compDetail?.compByLoanCategory,
    isTodayRequested: loanList?.todayRequested,
    sendBeaconClkBtnLoanApp,
    sendBeaconClkBtnAgree,
    showTerms,
  };
};

export default usePartners;
